import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const getPerformanceRequest = createRequest(constants.performance);
export const getPerformanceSuccess = createSuccess(constants.performance);
export const getPerformanceFailure = createFailure(constants.performance);

export const getPerformance = getPerformanceRequest;
